import { useSelector } from 'react-redux'

export default (() => {
  const getSettingsState = state => state.myAccountState.settingsState
  const useFromSettingsState = paramName => useSelector(state => getSettingsState(state)[paramName])

  return {
    useFromSettingsState
  }
})()
